<template>
    <button class="btn btn-primary" @click="showFlextimeModal">
        {{ $trans.get("__JSON__.Adjust flextime") }}
    </button>

    <Teleport to="body">
        <div class="modal" tabindex="-1" id="flextimemodal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $trans.get("__JSON__.Adjust flextime") }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="errors.length !== 0" class="alert alert-danger">
                            <div v-for="(value, key) in errors">
                                <li v-for="error in value">
                                    {{ error }}
                                </li>
                            </div>
                        </div>
                        <div class="mb-3">
                        {{ $trans.get("__JSON__.Flextime account") }} {{ formatTime(flextimehours) }} {{ $trans.get("__JSON__.Hours") }}
                        </div>  
                        <div class="mb-3">
                            <label for="difference">{{ $trans.get("__JSON__.Change") }}</label> &nbsp;
                            <input type="number" id="difference" v-model="difference" /> &nbsp; {{ $trans.get("__JSON__.minutes") }}
                            </div>  
                            <div class="mb-3">
                                {{ $trans.get("__JSON__.New") }} {{ formatTime(Math.round(newminutes / 6) / 10) }} {{ $trans.get("__JSON__.Hours") }}
                            </div>  
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            {{ $trans.get("__JSON__.Close") }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="saveAdjustment">
                            {{ $trans.get("__JSON__.Save") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </Teleport>
</template>

<script>
import { ref, watch } from "vue";

export default {
    name: "AdjustFlextime",
    props: {
        employee_id: String,
    },
    setup(props) {
    },
    data() {
        return {
            flextimehours: 0,
            difference: 0,
            newminutes: 0,
            errors: []
        };
    },
    watch: {
        difference: function (newValue, oldValue) {
            this.newminutes = this.flextimehours * 60 + this.difference;
        },
    },
    created() {
    },
    mounted() {
        this.getFlextimeHours();
    },
    computed: {
    },
    methods: {
        fetchData() {
        },
        getFlextimeHours() {
            axios
                .get("/api/flextimehours?employee_id=" + this.employee_id)
                .then((resp) => {
                    this.flextimehours = resp.data.flextime_hours;
                    this.newminutes = this.flextimehours * 60 + this.difference;
                })
                .catch((error) => {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });

        },
        formatTime(decimalHours) {
            var minus = '';
            if (decimalHours < 0) {
                minus = '-';
                decimalHours *= -1;
            }

            var hours = this.pad(Math.floor(decimalHours), 2);
            var minutes = this.pad((decimalHours - Math.floor(decimalHours))*60, 2);            

            return minus + hours + ":" + minutes;
        },
        pad(num, size) {
            var s = "000000000" + num;
            return s.substr(s.length - size);
        },
        saveAdjustment() {
            
            const flextimeaccount = {
                employee_id: this.employee_id,
                minutes: this.difference
            };

                axios
                .post("/api/flextimeaccounts", flextimeaccount)
                .then((resp) => {
                    console.log(resp.data);
                    $("#flextimemodal").modal("hide");
                    window.location.reload();
                })
                .catch((error) => {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });

            
        },
        showFlextimeModal() {
            $("#flextimemodal").modal("show");
        }
    }
}
</script>

<style lang="scss"></style>
